import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id       : 'applications',
        title    : 'Personal',
        // translate: 'NAV.APPLICATIONS',
        type     : 'group',
        children : [
            {
                id       : 'sample',
                title    : 'Mis Horas',
                // translate: 'NAV.SAMPLE.TITLE',
                type     : 'item',
                icon     : 'timer',
                url      : '/mishoras'
            },
            {
                id       : 'project',
                title    : 'Proyectos',
                type     : 'item',
                icon     : 'business',
                url      : '/proyecto/todos',
            }
        ]
    },
    {
        id       : 'gerencial',
        title    : 'Gerencial',
        type     : 'group',
        children : [
            // {
            //     id       : 'horas',
            //     title    : 'Horas',
            //     type     : 'item',
            //     icon     : 'timers',
            //     url      : '/hour'
            // },
            {
                id       : 'statistics',
                title    : 'Estadísticas',
                type     : 'item',
                icon     : 'timers',
                url      : '/statistics'
            }
            // {
            //     id       : 'plantillas',
            //     title    : 'Plantillas',
            //     type     : 'item',
            //     icon     : 'group',
            //     url      : '/types/templates',
            // }
        ]
    },
    {
        id       : 'administration',
        title    : 'Administracion',
        // translate: 'NAV.APPLICATIONS',
        type     : 'group',
        children : [
            {
                id       : 'usuarios',
                title    : 'Usuarios',
                type     : 'item',
                icon     : 'person',
                url      : '/administration/user'
            },
            {
                id       : 'teams',
                title    : 'Equipos',
                type     : 'item',
                icon     : 'group',
                url      : '/administration/team',
            }
            ,
            {
                id       : 'roles',
                title    : 'Roles',
                type     : 'item',
                icon     : 'account_box',
                url      : '/administration/role',
            }
            ,
            {
                id       : 'clients',
                title    : 'Clientes',
                type     : 'item',
                icon     : 'store',
                url      : '/administration/client',
            },
            {
                id       : 'instrumentType',
                title    : 'Tipo de Instrumento',
                type     : 'item',
                icon     : 'store',
                url      : '/administration/instrumentType',
            },
            {
                id       : 'instrumentModel',
                title    : 'Modelo de Instrumento',
                type     : 'item',
                icon     : 'store',
                url      : '/administration/instrumentModel',
            },
            {
                id       : 'icc',
                title    : 'ICC',
                type     : 'item',
                icon     : 'store',
                url      : '/administration/icc',
            }
            
        ]
    }
];
